// extracted by mini-css-extract-plugin
export default {"logo":"LayoutMenu_logo__gJiPc"};